import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';

import { withTitle, sectionTitle } from './FormSection.less';

const FormSection = ({ children, title, localeId, localeMessage, ...props }) => (
  <Grid fluid className={(title || localeId) && withTitle}>
    {(title || localeId) && (
      <Row>
        <Col xs={12}>
          <h6 className={sectionTitle} children={localeId ? localeMessage(localeId) : title || ''} />
        </Col>
      </Row>
    )}
    {children}
  </Grid>
);

FormSection.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  localeId: PropTypes.string,
  localeMessage: PropTypes.func,
};

export default FormSection;
